import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Empty } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import map from 'lodash/map';
import each from 'lodash/each';
import PropTypes from 'prop-types';
import Filter from '../../../components/Filter/index';
import User from './User';
import AddManagers from './AddManager';

function ManagerTab({
  users,
  getUsers,
  loadingUsers,
}) {
  const { t } = useTranslation();
  const [addManager, setAddManager] = useState(false);
  const [managers, setManagers] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    if (users) {
      if (users.length !== 0) {
        const group = [];
        each(users, (user) => {
          if (user.warehouse_permissions.length !== 0) {
            each(user.warehouse_permissions, (item) => {
              if (Number(id) === item.warehouse_id) {
                group.push({
                  permissions: user.warehouse_permissions,
                  user: {
                    name: user.first_name,
                    surname: user.last_name,
                    id: user.id,
                  },
                });
              }
            });
          }
        });
        setManagers(group);
      }
    }
  }, [users]);

  return (
    <div>
      <Filter manager placeholder={t('searchByName')} />
      {managers && managers.length !== 0 ? (
        <Row className="mt-10" type="flex" align="middle">
          <Col className="text-20 font-semibold text-black" span={6}>
            {t('rights')}
          </Col>
          <Col className="uppercase text-12 text-center" span={2}>
            {t('viewBoxes')}
          </Col>
          <Col className="uppercase text-12 text-center" span={2}>
            {t('boxManagement')}
          </Col>
          <Col className="uppercase text-12 text-center" span={2}>
            {t('openRented')}
          </Col>
          <Col className="uppercase text-12 text-center" span={2}>
            {t('CustomerManagement')}
          </Col>
          <Col className="uppercase text-12 text-center" span={2}>
            {t('CustomerManagement')}
          </Col>
          <Col className="uppercase text-12 text-center" span={4}></Col>
          <Col span={4}></Col>
        </Row>
      ) : null}
      {managers && managers.length !== 0 ? (
        map(managers, (item) => {
          return <User data={item.user} permissions={item.permissions[0]} />;
        })
      ) : (
        <Empty className="mt-50" />
      )}
      {addManager && (
        <AddManagers
          loadingUsers={loadingUsers}
          getUsers={getUsers}
          managers={managers}
          setAddManager={setAddManager}
          addManager={addManager}
          data={users}
        />
      )}
      <div className="mt-20 ml-20 mb-20 flex items-center">
        <Button
          onClick={() => {
            setAddManager(!addManager);
          }}
          className="flex items-center rounded-full w-17 h-17 mr-10 p-0 flex items-center justify-center"
          type="primary"
        >
          <PlusOutlined className="m-0" />
        </Button>
        {t('addAdmin')}
      </div>
    </div>
  );
}

ManagerTab.propTypes = {};

export default ManagerTab;
